import { BaseService } from '../../../shared/Services/BaseService';
import { authenticationService } from '../../../shared/Services/authenticationService';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ServicesHistoryervice extends BaseService {
  baseUrl: string;
  constructor(http: HttpClient, authenticationSerives: authenticationService) {
    const baseUrl = environment.apiUrl + 'ServiceHistory';

    super(http, authenticationSerives, baseUrl);
    this.baseUrl = baseUrl;
  }

  analysis(id) {
    return this.http.post(this.baseUrl + '/Analysis', { HistoryId: id });
  }
}
